import DefaultRequest from './DefaultRequest';

class Restrictions extends DefaultRequest {
  constructor(params) {
    const {
      entity,
      fieldKeys,
      criteria,
      method
    } = params;
    super(params);
    this.method = method || 'post';
    this.fieldKeys = fieldKeys || ['*'];
    this.data = criteria || { criteriaChain: [{ and: [{}] }] };
    this.url = `${entity}/restrictions?criteria=${JSON.stringify({ filters: fieldKeys })}`;
  }
}

export default Restrictions;
